// Libs
import * as React from "react";
import Button from "../shared/Button";
import styled from "styled-components";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
// Helpers
import Auth from "../lib/Auth";
// Store
import { authSuccess, IProfilePayload } from "../core/duck/actions";
// Assets
import logo from "../img/logo.png";

interface ILoginProps extends RouteComponentProps<{}> {
  authSuccess: (payload: IProfilePayload) => void;
}

interface ILoginState {
  error: string;
  authing: boolean;
}

class Login extends React.Component<ILoginProps, ILoginState> {
  public state = {
    error: "",
    authing: false
  }
  public async componentDidMount() {
    // Check if existing creds are still valid
    if (Auth.isAuthenticated()) {
      this.props.history.push("/views/new")
    // Hash from being redirected from Salesforce
    } else if (this.props.location.hash.includes('access_token')) {
      try {
        this.setState({ authing: true });
        const res = await Auth.handleAuthentication();
        const profile: any = { ...res };
        this.props.authSuccess(profile);
        this.setState({ authing: false });
        this.props.history.push("/views/new");
      } catch (e) {
        console.log(e);
        this.setState({
          error: "There was a problem logging you in, please try again."
        });
      }
    }
  }

  public login = () => {
    Auth.login();
  };

  public render() {
    return (
      <Outer>
        <LoginGroup>
          <img src={logo} alt="cushman and wakefield logo" />
          <Error>{this.state.error && this.state.error}</Error>
          <Button onButtonClick={this.login} loading={this.state.authing}>
            Login
          </Button>
        </LoginGroup>
      </Outer>
    );
  }
}

export default connect(
  null,
  { authSuccess }
)(withRouter(Login));

const Outer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 160px;
`;

const LoginGroup = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  > img:first-child {
    width: 209px;
    height: 44px;
    margin: 0 auto 15px auto;
  }
  .login-btn {
    width: 80px;
    margin: 0 auto;
  }
  > div {
    margin-bottom: 20px;
    &:before {
      border-bottom: 1px solid #0091b0;
    }
    input {
      width: 248px;
    }
  }
`;

const Error = styled.div`
  color: red;
  font-weight: 400;
`;



// WEBPACK FOOTER //
// ./src/login/Login.tsx